import { getIsShellBackgrounded, IS_SHELL, subscribeToShellMemoryWarning } from './browser/shellContainer';
import { recordClientDiagnosticEvent } from './clientDiagnostics';
import { releaseMemoryCacheUnderPressure } from './mediaLoader';
import { callEventWebAliveNative } from './nativeBridge';

const WEB_ALIVE_INTERVAL_MS = 15000;

let isInited = false;
let beatTimer: number | undefined;

function isForeground() {
  if (typeof document !== 'undefined' && document.hidden) return false;

  return !getIsShellBackgrounded();
}

function tick() {
  if (!isForeground()) return;

  callEventWebAliveNative();
}

function handleMemoryWarning() {
  const released = releaseMemoryCacheUnderPressure();
  recordClientDiagnosticEvent({
    type: 'shell_memory_warning',
    reason: `released:${released}`,
    success: true,
  }, { upload: true });
}

export function initShellWatchdog() {
  if (isInited) return;
  isInited = true;

  subscribeToShellMemoryWarning(handleMemoryWarning);

  if (!IS_SHELL) return;

  beatTimer = window.setInterval(tick, WEB_ALIVE_INTERVAL_MS);
  tick();
}

export function stopShellWatchdog() {
  if (beatTimer !== undefined) {
    window.clearInterval(beatTimer);
    beatTimer = undefined;
  }
}
